import { ErrorHandler, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BusinessFinderService } from './business-finder.service';
import { FboResult } from '../models/fbo-result.model';
import { LatLon } from '../../util/geodesy/latlon';
import { BoundingBox } from '../../util/geodesy/bounding-box';

/**
 * HTTP service for the Business Finder (FBOs). Calls the AirportsAPI `~/fbos` endpoint. Category facet
 * filtering (Amenities / Facilities / Fuel / Line Services / ...) is applied client-side in
 * {@link SearchPageComponent}; this service performs only the location/state/keyword query.
 */
@Injectable({
  providedIn: 'root'
})
export class FbosService extends BusinessFinderService<FboResult> {

  protected readonly endpoint = 'fbos';

  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  protected parse(data: any): FboResult {
    return FboResult.parse(data);
  }

  getFbosByLatLon(latlon: LatLon, radius: number): Promise<FboResult[]> {
    return this.getByLatLon(latlon, radius);
  }

  getFbosByBoundingBox(bounds: BoundingBox): Promise<FboResult[]> {
    return this.getByBoundingBox(bounds);
  }

  getFbosByState(state: string): Promise<FboResult[]> {
    return this.getByState(state);
  }

  getFbosBySearchTerm(term: string): Promise<FboResult[]> {
    return this.getBySearchTerm(term);
  }
}
